
export default {
  name: "sidebar",
  data: () => ({
    miniSide: false,
    items: [
      {
        action: "mdi-home",
        title: "sideBar.side.home",
        path: "/",
        includeList: false,
      },
      {
        action: "mdi-contacts",
        title: "sideBar.side.about",
        path: "/about",
        includeList: false,
      },
      {
        action: "mdi-podium",
        title: "sideBar.side.services",
        // path: "/services",
        includeList: true,
        list: [
          { title: "sideBar.servicesList.link1", path: "/services" },
          { title: "sideBar.servicesList.link2", path: "/services" },
          { title: "sideBar.servicesList.link3", path: "/services" },
          { title: "sideBar.servicesList.link4", path: "/services" },
          { title: "sideBar.servicesList.link5", path: "/services" },
          { title: "sideBar.servicesList.link6", path: "/services" },
        ],
      },
      // {
      //   action: "mdi-lightbulb-on-outline",
      //   title: "sideBar.side.solutions",
      //   // path: "",
      //   includeList: true,
      //   list: [
      //     { title: "sideBar.solutionsList.link1", path: "" },
      //     { title: "sideBar.solutionsList.link2", path: "" },
      //     { title: "sideBar.solutionsList.link3", path: "" },
      //     { title: "sideBar.solutionsList.link4", path: "" },
      //   ],
      // },
      {
        action: "mdi-check-decagram",
        title: "sideBar.side.products",
        // path: "/test",
        includeList: true,
        list: [
          { title: "sideBar.productsList.link1", path: "/system" },
          { title: "sideBar.productsList.link2", path: "/systemTow" },
        ],
      },
      {
        action: "mdi-briefcase-search",
        title: "sideBar.side.recruitment",
        path: "/jobs",
        includeList: false,
      },
      {
        action: "mdi-ticket",
        title: "sideBar.side.tickets",
        path: "/ticket",
        includeList: false,
      },
      {
        action: "mdi-account-hard-hat",
        title: "sideBar.side.itSupport",
        path: "/logIn",
        includeList: false,
      },

      {
        action: "mdi-phone-in-talk",
        title: "sideBar.side.contactUs",
        path: "/contact",
        includeList: false,
      },
    ],
  }),
  watch: {
    "$store.state.drawerAll": {
      deep: true, // for arrays and objects
      handler() {
        const that = this as any;
        that.miniSide = that.$store.state.drawerAll.mini;
      },
    },
    "$vuetify.breakpoint.name": {
      immediate: true, // بتشتغل اول ما الصفحة تحمل
      deep: true, // for arrays and objects
      handler(): any {
        const that = this as any;
        const val = that.$vuetify.breakpoint.name;
        let drawer = Object.assign({}, that.$store.state.drawerAll); // copy of the object

        if (val == "xs" || val == "sm" || val == "md") {
          drawer.view = false;
        } else {
          drawer.view = false;
        }
        that.$store.commit("get_drawer", drawer);
      },
    },
  },
  methods: {
    open() {
      const that = this as any;
      const drawer = that.$store.state.drawerAll;
      if (drawer.mini) {
        that.miniSide = false;
      }
    },
    close() {
      const that = this as any;
      const drawer = that.$store.state.drawerAll;
      if (drawer.mini) {
        that.miniSide = true;
      }
    },
    manualClose() {
      const that = this as any;
      let drawer = Object.assign({}, that.$store.state.drawerAll);
      if (drawer.view) {
        drawer.view = !drawer.view;
      }
      that.$store.commit("get_drawer", drawer);
    },
  },
};
